export default "__VITE_ASSET__DEOCQFhT__"